import axios from "axios";
import {
    getForgotPasswordUrl,
    getVerifyOtpUrl,
    getResetPasswordUrl,
    getAdminInitiateResetUrl,
} from "utils/endpointUtils/forgotPasswordEndpointUtil";
import { setAuthHeader } from "app/services/auth.header.service";

/**
 * Forgot-password with OTP — talks to the public endpoints on user-auth.
 * These endpoints do not require authentication.
 */

// Step 1 — request an OTP for the given email. Always resolves 200 (server is deliberately
// silent about whether the account exists).
export const requestPasswordResetOtp = (email) => {
    return axios.post(getForgotPasswordUrl(), { email });
};

// Step 2 — verify the OTP; on success the response carries a single-use resetToken.
export const verifyPasswordResetOtp = (email, otp) => {
    return axios.post(getVerifyOtpUrl(), { email, otp });
};

// Step 3 — consume the resetToken and set the new password.
export const resetPasswordWithToken = (resetToken, newPassword, confirmNewPassword) => {
    return axios.post(getResetPasswordUrl(), { resetToken, newPassword, confirmNewPassword });
};

// Admin-assisted recovery (ADMIN only). Generates an OTP for `targetEmail` and delivers it
// to `deliverToEmail` (optionally CC `ccEmail`). Requires an authenticated ADMIN session —
// attach the JWT per-request via setAuthHeader() (reads it from the session store), so the call
// works even after a page reload when the global axios default header isn't set.
export const adminInitiateReset = (targetEmail, deliverToEmail, ccEmail) => {
    const payload = { targetEmail, deliverToEmail };
    if (ccEmail && ccEmail.trim() !== "") {
        payload.ccEmail = ccEmail.trim();
    }
    return axios.post(getAdminInitiateResetUrl(), payload, setAuthHeader());
};
